'use client'

import React, { useState } from 'react'
import { useServerInsertedHTML } from 'next/navigation'
import { StyleRegistry, createStyleRegistry } from 'styled-jsx'

/* FOUC root-cause fix: the App Router never server-renders styled-jsx without
   this registry — every component's <style jsx> was arriving only at client
   hydration, so pages painted ~1s of unstyled HTML. With the registry, styles
   are flushed into the streamed HTML alongside the markup. */
export default function StyledJsxRegistry({ children }: { children: React.ReactNode }) {
  const [registry] = useState(() => createStyleRegistry())

  useServerInsertedHTML(() => {
    const styles = registry.styles()
    registry.flush()
    return <>{styles}</>
  })

  return <StyleRegistry registry={registry}>{children}</StyleRegistry>
}
